import { forwardRef, type Ref, type SVGProps } from "react";
const IconFullScreenFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M28 2H4a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2M13.71 19.71 9.42 24H12a1 1 0 0 1 0 2H7a.7.7 0 0 1-.25 0 .4.4 0 0 1-.14 0 .94.94 0 0 1-.53-.53.4.4 0 0 1 0-.14A.7.7 0 0 1 6 25v-5a1 1 0 0 1 2 0v2.58l4.29-4.29a1 1 0 0 1 1.42 1.42m0-6a1 1 0 0 1-1.42 0L8 9.42V12a1 1 0 0 1-2 0V7a.7.7 0 0 1 0-.25.4.4 0 0 1 0-.14.94.94 0 0 1 .53-.53.4.4 0 0 1 .14 0A.7.7 0 0 1 7 6h5a1 1 0 0 1 0 2H9.42l4.29 4.29a1 1 0 0 1 0 1.42M26 25a.7.7 0 0 1 0 .25.4.4 0 0 1 0 .14.94.94 0 0 1-.53.53.4.4 0 0 1-.14 0A.7.7 0 0 1 25 26h-5a1 1 0 0 1 0-2h2.58l-4.29-4.29a1 1 0 0 1 1.42-1.42L24 22.58V20a1 1 0 0 1 2 0zm0-13a1 1 0 0 1-2 0V9.42l-4.29 4.29a1 1 0 0 1-1.42 0 1 1 0 0 1 0-1.42L22.58 8H20a1 1 0 0 1 0-2h5a.7.7 0 0 1 .25 0 .4.4 0 0 1 .14 0 .94.94 0 0 1 .53.53.4.4 0 0 1 0 .14A.7.7 0 0 1 26 7z" />
  </svg>
);
const ForwardRef = forwardRef(IconFullScreenFilledSVG);
ForwardRef.displayName = "IconFullScreenFilled";
export { ForwardRef as IconFullScreenFilled };
